const r = "app.partoo.co", s = "admin.partoo.co", c = "app.mavisibiliteweb.fr", i = "https://jssdk-playground.partoo.co", t = "slates", l = [
  r,
  s,
  c,
  i
], O = () => {
  const e = window.location.hostname;
  if (l.includes(e))
    return { reference: null, subdomain: "" };
  const n = /^([a-z0-9]+)?\.?(app|admin|jssdk-playground)\.([^.]+)\.partoo\.co/i.exec(e);
  if (!n)
    return { reference: null, subdomain: null };
  const a = n[1] ?? null, o = n[3] === t ? t : n[3] ?? "";
  return o === t ? { reference: a, subdomain: o } : { reference: null, subdomain: o };
};
export {
  l as PROD_HOSTNAMES,
  O as extractPartooSubdomain
};
